import { Stack } from '@mui/material';

import RadioGroup from '../../../../../components/FormControls/RadioGroup';
import PollWidgetSkeleton from '../../../PollWidget/Skeleton';
import { pollListClasses, RadioOption } from './styles';

export interface PollListSkeletonProps {
  className?: string;
}

const PollListSkeleton = ({ className }: PollListSkeletonProps) => {
  return (
    <RadioGroup fullWidth className={className}>
      <Stack gap={2} px={2} py={0.5} my={-0.5} maxWidth="100%">
        {new Array(3).fill('').map((_, index) => (
          <RadioOption key={index} value={`${index}`}>
            <PollWidgetSkeleton className={pollListClasses.pollCard} />
          </RadioOption>
        ))}
      </Stack>
    </RadioGroup>
  );
};

export default PollListSkeleton;
